/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/locale';
import '../../../../precog/v2/common';
import '../../resources/product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "ListRecommendedProductsRequest": {
                    "fields": {
                      "productKeys": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      },
                      "limit": {
                        "type": "int32",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": 25
                        }
                      },
                      "rawSubAudience": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "subAudience": {
                        "type": "squareup.precog.api.v2.Subaudience",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListRecommendedProductsResponse": {
                    "fields": {
                      "products": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE ListRecommendedProductsRequest @ squareup/solidshop/v2/service/products/list_recommended_products.proto at 13:1
 */
export const ListRecommendedProductsRequest = $root.lookupType('squareup.solidshop.v2.service.ListRecommendedProductsRequest');
fixType(ListRecommendedProductsRequest);
Builder.createAndAttachToType(ListRecommendedProductsRequest);
/**
 * SOURCE ListRecommendedProductsResponse @ squareup/solidshop/v2/service/products/list_recommended_products.proto at 34:1
 */
export const ListRecommendedProductsResponse = $root.lookupType('squareup.solidshop.v2.service.ListRecommendedProductsResponse');
fixType(ListRecommendedProductsResponse);
Builder.createAndAttachToType(ListRecommendedProductsResponse);
